<div class="container">
  <div class="row">
    <div class="col-8">
      <h1 class="page-title">{{ headerTitle | globalTranslate }}</h1>
    </div>
  </div>
  <div class="card mb-4 bg-custom-register">
    <h2 class="section-header">{{ sectionTitle | globalTranslate }}</h2>
    <hr />
    @if (isChangeEmailLinkValid) {
    <section>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <p>
            <span [innerHtml]="'EMAIL_CHANGE' | globalTranslate"></span>
            <strong [innerHtml]="'BACK_TO_LOGIN' | globalTranslate"></strong>
            <span [innerHtml]="'EMAIL_CHANGE_01' | globalTranslate"></span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="pt-1 col-md-12 col-xs-12 hover-red comments">
          <a class="btn btn-link hover-red" [routerLink]="['/signin']">
            <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
            <nh-exit-svg></nh-exit-svg>
          </a>
        </div>
      </div>
    </section>
    } @if (!isChangeEmailLinkValid) {
    <section>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <p>{{ "CHANGE_EMAIL_LINK_EXPIRED" | globalTranslate }}</p>
        </div>
      </div>
      <div class="row">
        <div class="pt-1 col-md-12 col-xs-12 hover-red comments">
          <a class="btn btn-link hover-red" [routerLink]="['/signin']">
            <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
            <nh-exit-svg></nh-exit-svg>
          </a>
        </div>
      </div>
    </section>
    }
  </div>
</div>